import React from "react";
import { Link } from "react-router-dom";
import { Gauge, Fuel, Cog, MapPin, MessageCircle, ArrowUpRight } from "lucide-react";
import ImageSlider from "./ImageSlider";
import { formatPrice, formatKm, waLink } from "../lib/api";

export default function CarCard({ car }) {
  const enquiry = waLink(
    `Hello Faisal Car Bazar, I'm interested in the ${car.year} ${car.name} (${formatPrice(car.price)}). Please share more details.`,
  );
  const sold = car.status === "sold";

  return (
    <article
      data-testid={`car-card-${car.id}`}
      className="premium-card hover-glow flex flex-col"
    >
      <div className="relative">
        <ImageSlider
          images={car.images}
          alt={car.name}
          testId={`car-slider-${car.id}`}
          aspect="aspect-[4/3]"
        />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.2em] bg-[#0A0A0A]/80 border border-white/10 text-[#D4AF37]">
            {car.year}
          </span>
          {car.featured && !sold && (
            <span className="px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.2em] bg-[#DC143C] text-white">
              Featured
            </span>
          )}
        </div>
        {sold && (
          <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
            <span className="px-6 py-2 rounded-full bg-[#DC143C] text-white text-sm uppercase tracking-[0.3em] font-medium">
              Sold
            </span>
          </div>
        )}
      </div>

      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-3 mb-1">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] mb-1">
              {car.brand}
            </div>
            <h3 className="font-display text-xl text-[#F5F5DC] truncate">
              {car.name}
            </h3>
            <p className="text-xs text-[#A0A0A0] truncate">{car.model}</p>
          </div>
          <div className="text-right">
            <div className="font-display text-xl text-[#DC143C] whitespace-nowrap">
              {formatPrice(car.price)}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 mt-4 text-xs text-[#F5F5DC]/80">
          <div className="flex items-center gap-2">
            <Gauge size={14} className="text-[#D4AF37]" />
            <span>{formatKm(car.kilometers)}</span>
          </div>
          <div className="flex items-center gap-2">
            <Fuel size={14} className="text-[#D4AF37]" />
            <span>{car.fuel_type}</span>
          </div>
          <div className="flex items-center gap-2">
            <Cog size={14} className="text-[#D4AF37]" />
            <span>{car.transmission}</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin size={14} className="text-[#D4AF37]" />
            <span className="truncate">{car.location}</span>
          </div>
        </div>

        <div className="mt-5 pt-4 border-t border-white/5 flex gap-2">
          <Link
            to={`/inventory/${car.id}`}
            data-testid={`car-view-${car.id}`}
            className="flex-1 bg-white/5 hover:bg-white/10 text-[#F5F5DC] text-xs tracking-wider uppercase rounded-full py-2.5 flex items-center justify-center gap-1.5 border border-white/10 transition-all"
          >
            View Details <ArrowUpRight size={14} />
          </Link>
          <a
            data-testid={`car-whatsapp-${car.id}`}
            href={enquiry}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#25D366] hover:bg-[#1ebd5b] text-white rounded-full p-2.5 transition-all"
            aria-label="WhatsApp enquiry"
          >
            <MessageCircle size={16} />
          </a>
        </div>
      </div>
    </article>
  );
}
